import React from 'react';
import { InvoiceItem } from '../../../../types/invoice/AddInvoice';
import { ErrorMessage, Field, FormikErrors } from 'formik';
import { taxOptions } from '../AddInvoiceSection';
import { Button, Label, UncontrolledTooltip, Row, Col } from 'reactstrap';
import { Trash2 } from 'react-feather';

interface ItemRowProps {
  item: InvoiceItem;
  itemIdx: number;
  itemErrors: FormikErrors<InvoiceItem>;
  setFieldValue: (field: string, value: any) => void;
  handleKeyPress: (e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>, fieldName: string) => void;
  remove: () => void;
  t: (key: string) => string;
}

export const EditableItemRow: React.FC<ItemRowProps> = ({ item, itemIdx, itemErrors, setFieldValue, handleKeyPress, remove, t }) => {
  const itemTotal = Number(item.quantity || 0) * Number(item.price || 0) - Number(item.discount || 0);

  return (
    <div className="d-flex align-items-center flex-wrap p-3">
      <span className="badge bg-primary me-3 mt-4" style={{ minWidth: 26, fontSize: 12 }}>
        {itemIdx + 1}
      </span>
      <Row className="flex-grow-1 g-2">
        {[
          { name: 'item', type: 'text', placeholder: t('Item'), label: t('Item'), xs: 6, md: 2 },
          { name: 'quantity', type: 'number', placeholder: t('Quantity'), label: t('Quantity'), xs: 6, md: 2 },
          { name: 'price', type: 'text', placeholder: t('Price'), label: t('Price'), xs: 6, md: 2 },
          { name: 'discount', type: 'text', placeholder: t('Discount (Optional)'), label: t('Discount'), xs: 6, md: 2 },
          { name: 'taxRate', type: 'select', placeholder: t('Tax'), label: t('Tax'), xs: 6, md: 2 },
        ].map(({ name, type, placeholder, label, xs, md }) => (
          <Col xs={xs} md={md} key={name}>
            <Label className="text-dark fw-small mb-1">{label}</Label>
            {type === 'select' ? (
              <Field
                name={`invoiceItems[${itemIdx}].${name}`}
                as="select"
                className="form-control"
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setFieldValue(`invoiceItems[${itemIdx}].${name}`, e.target.value)}
                onKeyDown={(e: React.KeyboardEvent<HTMLSelectElement>) => handleKeyPress(e, name)}
              >
                {taxOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Field>
            ) : (
              <Field
                name={`invoiceItems[${itemIdx}].${name}`}
                type={type}
                className="form-control"
                placeholder={placeholder}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue(`invoiceItems[${itemIdx}].${name}`, e.target.value)}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => handleKeyPress(e, name)}
              />
            )}
            <ErrorMessage
              name={`invoiceItems[${itemIdx}].${name}`}
              component="span"
              className="text-danger mt-1 d-block small"
              render={(msg) => (typeof msg === 'string' ? <span style={{ color: 'red' }}>{msg}</span> : null)}
            />
          </Col>
        ))}
        <Col xs={6} md={1} lg={1} >
          <Label className="text-dark fw-small mb-1">{t('Total')}</Label>
          <div className="form-control-plaintext fw-bold text-success w-100 mt-2">${itemTotal.toFixed(2)}</div>
        </Col>
        <Col xs={6} md={1} lg={1} className='pt-4'>
          <Button
            className="p-2 mt-2"
            id={`delete-item-${itemIdx}`}
            color="link"
            size="sm"
            type="button"
            onClick={remove}
          >
            <Trash2 size={18} />
          </Button>
          <UncontrolledTooltip target={`delete-item-${itemIdx}`}>
            {t('Delete Item')}
          </UncontrolledTooltip>
        </Col>
      </Row>
    </div>
  );
};